<template>
  <div>
    <v-checkbox
      v-if="label"
      :label="label"
      v-model="localValue"
      class="mb-4"
      :disabled="schema.removeable"
    />
  </div>
</template>
<script>
export default {
  name: 'ReportObject',
  props: {
    value: {},
    schema: {
      type: Object,
      default: () => ({}),
    },
  },

  methods: {
    setInput(val) {
      this.$emit('input', val);
    },
  },

  computed: {
    label() {
      const value = this.value || {};
      return Object.entries(value)
        .map((entry) => {
          return `${entry[0]}: ${entry[1]}`;
        })
        .join(', ');
    },

    localValue: {
      get() {
        return !!this.value;
      },
      set(value) {
        if (!value) {
          this.$emit('input', null);
        }
      },
    },
  },
};
</script>
